<template>
  <div class="panel">
    <div v-if="!isPeriodValid" class="notice">
      Sélectionnez une <strong>date de début</strong> antérieure ou égale à la <strong>date de fin</strong> pour afficher les statistiques.
    </div>
    <div v-else-if="hasFailed" class="notice">Les statistiques n'ont pas pu être chargées. Modifiez la période ou rechargez la page.</div>
    <template v-else-if="data">
      <div class="content" :class="{stale: isLoading}">
        <slot :data="data" />
      </div>
    </template>
    <div v-if="isLoading" class="loading">Chargement…</div>
  </div>
</template>

<script>
import {StatisticsService} from "@/statistics/services/StatisticsService";

/**
 * Charge les données d'un sous-onglet pour la période choisie (et les recharge quand elle change),
 * puis les donne au contenu : <StatisticsPanel :load="..." v-slot="{ data }">.
 */
export default {
  name: 'StatisticsPanel',
  props: {
    // Appel du back avec les paramètres d'URL de la période, ex : StatisticsController.getClients
    load: {type: Function, required: true},
  },
  data() {
    return {
      data: undefined,
      isLoading: false,
      hasFailed: false,
      requestId: 0,
    };
  },
  computed: {
    isPeriodValid() {
      return !!StatisticsService.urlParams();
    },
    // Les paramètres qui déclenchent un nouveau chargement
    urlParams() {
      return StatisticsService.urlParams();
    },
  },
  watch: {
    urlParams() {
      this.fetch();
    },
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      if (!this.urlParams) return;
      // Une réponse tardive d'une ancienne période ne doit pas écraser la dernière demandée
      const requestId = ++this.requestId;
      this.isLoading = true;
      const resp = await this.load(this.urlParams);
      if (requestId !== this.requestId) return;
      this.hasFailed = !resp || !!resp.errors;
      if (!this.hasFailed) this.data = resp;
      this.isLoading = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.panel
  position relative

.content
  transition opacity .15s

  &.stale
    opacity .55

.notice
  display flex
  justify-content center
  padding 40px 20px
  text-align center
  color CTRL_TEXT_MUTED
  background white
  border 1px dashed #dbe1ec
  border-radius 14px

.loading
  position absolute
  top 0
  right 0
  padding 5px 12px
  font-size 12px
  font-weight 600
  color THEME_COLOR_PRIMARY
  background rgba(255,255,255,.9)
  border-radius 20px
</style>
